import { TConfig } from 'lib/common/types/Config';

import { TQueueFilters, TQueueWhitelistItem } from './types';

export const getQueueConfig = (
  config: TConfig
): { queueWhitelist?: TQueueWhitelistItem[]; queueFilters?: TQueueFilters } => {
  const { QUEUE_WHITELIST, QUEUE_FILTERS } = config || {};

  return {
    queueWhitelist: QUEUE_WHITELIST || [],
    queueFilters: QUEUE_FILTERS || undefined,
  };
};
